import { createComponents, NO_PATTERN_BUSINESS_LOGIC, } from '@vfde-brix/ws10/core';
import { createColorSwatch } from './ColorSwatch';
import { COLOR_SWATCH_BASE_CLASSNAME } from './Constants';
createComponents(".".concat(COLOR_SWATCH_BASE_CLASSNAME), createColorSwatch, NO_PATTERN_BUSINESS_LOGIC);
